import { FC } from 'react';
import { faCameraLight } from '~/assets';
import {
  ButtonOk,
  Description,
  DescriptionBold,
  ModalIcon,
  Title,
  Wrapper,
} from './styles';

type Props = {
  isOpen: boolean;
  onClose(): void;
};

const ModalSelfieInstructions: FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Wrapper isOpen={isOpen} onClose={onClose} closeOnOverlayClick>
      <ModalIcon icon={faCameraLight} />
      <Title>Dicas para você tirar uma boa foto:</Title>
      <Description>
        A foto deve ser capturada de <DescriptionBold>frente</DescriptionBold>
        <br />
        <DescriptionBold>Centralizar o rosto</DescriptionBold> na guia
        <br />
        <DescriptionBold>Não faça caretas e não sorria</DescriptionBold>
        <br />
        <DescriptionBold>Não use óculos ou boné</DescriptionBold>
        <br />
        Posicione o celular na{' '}
        <DescriptionBold>altura dos olhos</DescriptionBold>
      </Description>
      <ButtonOk id="btn_ok" onPress={onClose} fullWidth>
        ENTENDI
      </ButtonOk>
    </Wrapper>
  );
};

export default ModalSelfieInstructions;
